import { Link as ReactLink } from 'react-router-dom';
import styled from 'styled-components';

const CustomLink = styled.a`
  color: ${({ theme }) => theme.colors.link};
  font-weight: 400;
  display: contents;
`;
export const InnerLink = styled(ReactLink)`
  color: ${({ theme }) => theme.colors.link};
  font-weight: 400;
`;

export default CustomLink;
